module.exports = __webpack_public_path__ + "static/media/cell-mob.21e146a8.png";